import Request from './request';


// export const base = 'http://192.168.2.123:8070';
// export const socketUrl = 'ws://192.168.2.123:8070/websocket/DDD';

// export const base = 'http://47.104.173.77:8089';
// export const socketUrl = `wss://api-test.skylimit.com`;

//开发环境
// export const base = 'http://192.168.2.174:8070';
// export const socketUrl = 'ws://192.168.2.174:8070/websocket/DDD';

//测试环境

// export const base = 'https://api-test.skylimit.com';
// export const socketUrl = 'wss://api-test.skylimit.com';

//生产环境
 export const base = 'https://api.skylimit.com';
 export const socketUrl = 'wss://api.skylimit.com';


export const url = {
    /**
     * 获取首页数据（项目排队、当前队列）
     */



    /**
     * 调整顺序
     */
    changeSeat:`${base}/soreal/control/modifySort`,
    /**
     * 备注客人状态
     */
    updateGuestStatus:`${base}/soreal/control/modifyCustomerStatus`,

    /**
     * 登录
     */
    login:`${base}/soreal/control/login`,
    /**
     * 获取首页数据（排场情况）
     */
    scene:`${base}/soreal/control/queueInfo`,
    /**
     * 获取首页数据（顾客队列）
     */
    customerQueue:`${base}/soreal/control/index`,
    /**
     * 叫号记录
     */
    selectCallList:`${base}/soreal/control/selectCallList`,
    /**
     * 置顶
     */
    meadTops:`${base}/soreal/control/modifyStick`,
    /**
     * 取消排队记录
     */
    cancelList:`${base}/soreal/control/selectDropList`,
    /**
     * 备注客户优先级
     */
    modifyPriority:`${base}/soreal/control/modifyPriority`,
    /**
     * 区域视图
     */
    queuesV:`${base}/soreal/control/view`,
    /**
     * 区域管理（获取门店区域和游戏）
     */
    storeAreaGame:`${base}/soreal/control/selectArea`,
    /**
     * 区域管理（根据选中的游戏配置获取当前区域下游戏）
     */
    getAreaGameList:`${base}/soreal/control/selectQueue`,
    /**
     * 区域管理（配置当前区域下游戏）
     */
    disposeGame:`${base}/soreal/control/modifyQueueGame`,
    /**
     * 区域管理（换区是查询同一区域下的下游戏）
     */
    getidentGame:`${base}/soreal/control/selectGameArea`,
    /**
     * 区域管理（确认更换区域）
     */
    changeArea:`${base}/soreal/control/modifyArea`,
    /**
     * 区域管理（区域维护开启/关闭）
     */
    maintainArea:`${base}/soreal/control/modifyAreaStatus`,
    /**
     * 区域管理（区域排队开启/关闭）
     */
    queueUpArea:`${base}/soreal/control/modifyQueueStatus`,
    /**
     * 区域管理（取消排队）
     */
    cancelQueue:`${base}/soreal/control/cancelQueue`,
    /**
     * 区域管理（开始/结束 游戏）
     */
    startOrEndGame:`${base}/soreal/control/changeGame`,
    /**
     * 区域管理（叫号）
     */
    callNumber:`${base}/soreal/control/call`,
    /**
     * 区域管理（等待叫号）
     */
    waitCallNumber:`${base}/soreal/control/waitCall`

}

export default {
    /**
     * 登录
     */
    login(params){
        const _url = url.login;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 获取首页数据（排场情况）
     */
    getIndex(params) {
        const _url = url.scene;
        return new Promise((reslove, reject) => {
            Request.get(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 获取首页数据（顾客队列）
     */
    getCustomerQueue(params){
        const _url = url.customerQueue;
        return new Promise((reslove, reject) => {
            Request.get(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 叫号记录列表
     */
    callNumberRecord(body){
        const _url = url.selectCallList;
        return new Promise((reslove, reject) => {
            Request.get(_url,body).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 修改顾客状态
     */
    updateGuestStatusType(params){
        const _url = url.updateGuestStatus;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 置顶
     */
    meadTops(params){
        const _url = url.meadTops;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 取消排队记录
     */
    cancelHosity(storeId,queueId){
        const _url = url.cancelList;
        return new Promise((reslove, reject) => {
            Request.get(`${_url}?storeId=${storeId}&queueId=${queueId}`).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 备注客户优先级
     */
    upDatePriorityMarks(params){
        const _url = url.modifyPriority;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域视图
     */
    queuesView(storeId){
        const _url = url.queuesV;
        return new Promise((reslove, reject) => {
            Request.get(`${_url}?storeId=${storeId}`).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（获取门店区域和游戏）
     */
    getStoreAreaGame(storeId){
        const _url = url.storeAreaGame;
        return new Promise((reslove, reject) => {
            Request.get(`${_url}?storeId=${storeId}`).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })

    },
    /**
     * 区域管理（获取当前区域下游戏）
     */
    getNewAreaGameList(areaId,gameIds){
        const _url = url.getAreaGameList;
        return new Promise((reslove, reject) => {
            Request.get(`${_url}?areaId=${areaId}&gameIds=${gameIds}`).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（配置当前区域下游戏）
     */
    disposeAreaGameList(params){
        const _url = url.disposeGame;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（换区是查询同一区域下的下游戏）
     */
    getIdenticalGame(storeId,gameId){
        const _url = url.getidentGame;
        return new Promise((reslove, reject) => {
            Request.get(`${_url}?storeId=${storeId}&gameId=${gameId}`).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（确认更换区域）
     */
    eChangeArea(params){
        const _url = url.changeArea;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（区域维护开启/关闭）
     */
    emaintainArea(params){
        const _url = url.maintainArea;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（区域排队开启/关闭）
     */
    eQueueUpArea(params){
        const _url = url.queueUpArea;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（取消排队）
     */
    eCancelQueue(params){
        const _url = url.cancelQueue;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（开始/结束 游戏）
     */
    eStartOrEndGame(params){
        const _url = url.startOrEndGame;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（叫号）
     */
    eCallnumber(params){
        const _url = url.callNumber;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     * 区域管理（等待叫号）
     */
    ewaitCallNumber(params){
        const _url = url.waitCallNumber;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },
    /**
     *拖拽调序
     */
    changeSeat(params){
        const _url = url.changeSeat;
        return new Promise((reslove, reject) => {
            Request.post(_url,params).then(res => {
                //服务器正常
                if (res.code == 200) {
                    //接口正常
                    reslove(res.data);
                } else {
                    reject(res.msg);
                }
            }).catch(e => {
                console.error(e)
                reject(e);
            })
        })
    },       
}



